<div class="input-box">
  <input data-testid="auto-app-multiselect-search-input-1"
  type="text"
  placeholder="Search {{filtertype | titlecase}}"
  [formControl]="searchText"
  class="search-input"
  (input)="onTypeSearch($event.target.value)" *ngIf="filtertype != 'companysize'"
  />
  <i class="fa-solid fa-magnifying-glass" *ngIf="filtertype != 'companysize'"></i>
</div>
<div class="typeaheadLists">
  <label class="custom-checkbox"  *ngFor="let typeahead of displayedLists" (click)="$event.stopPropagation()">
    <input data-testid="auto-app-multiselect-search-input-2"
      type="checkbox"
      id="myCheckbox"
      name="myCheckbox"
      (change)="selectMultipleData($event, typeahead)"
      [checked]="checkedOptions.includes(typeahead.key)"

    />
    <span class="checkmark"></span>
   <span class="text-truncate" matTooltip="{{typeahead.key}}" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{ typeahead.key | titlecase}}</span>
  </label>
</div>

<div class="button-group">
  <button data-testid="auto-app-multiselect-search-button-1" class="btn-trms-regular" (click)="resetFilters()">Reset</button>
  <button data-testid="auto-app-multiselect-search-button-2" class="btn-trms-xs-small" (click)="applyFilters()">Apply</button>
</div>
